import Ajax from '@utils/ajax';

export function checkUrlExists(url) {
	return Ajax.get(url).then(
		() => true,
		() => false
	);
}
